import { compose, createStore } from 'redux';

import { enhancer } from './enhancer';
import { reducer } from '../reducers';

import { INITIAL_STATE } from '../constants/store';

function createStoreWithDevtools(rootReducer, initialState) {
  const composeWithDevTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return createStore(rootReducer, initialState, composeWithDevTools());
}

const configureStore = enhancer(
  process.env.NODE_ENV === 'development'
    ? createStoreWithDevtools
    : createStore
);

export const store = configureStore(reducer, INITIAL_STATE);
